import {
  AuthPageContentBase,
  type AuthPageContentBaseProps,
} from "@core/features/auth";
import { PollinatorLogo } from "@themes/pollinator/ui/PollinatorLogo";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = Omit<
  AuthPageContentBaseProps,
  "renderHeader" | "contentClassName"
>;

export function AuthPageContent({
  children,
  title,
  description,
  className,
}: Props) {
  return (
    <AuthPageContentBase
      title={title}
      description={description}
      className={
        className ||
        "flex flex-col md:border md:border-brand-800 rounded-lg w-full max-w-xl mx-auto md:shadow-lg pb-8"
      }
      contentClassName="w-full max-w-sm mx-auto flex flex-col gap-8"
      renderHeader={({ title, description }) => (
        <div className="flex flex-col items-center justify-center p-8 gap-8">
          <div className="flex flex-col items-center justify-center gap-4 w-full max-w-sm mx-auto">
            <PollinatorLogo className="mx-auto" size="sm" />
            <Type as="h1" variant="h3" className="text-center">
              {title}
            </Type>
            <Type as="p" variant="body1" className="text-center">
              {description}
            </Type>
          </div>
        </div>
      )}
    >
      {children}
    </AuthPageContentBase>
  );
}

export default AuthPageContent;

